import { useQuery } from "@tanstack/react-query";
import { get } from "../../api/client";

export const AUDIENCE_KEY = {
  AUDIENCE_KEY: "AUDIENCE_KEY",
};

export const useGetAudienceOptions = () =>
  useQuery([AUDIENCE_KEY.AUDIENCE_KEY], () => {
    return get({
      url: "api/v1/audience/options",
    });
  });

export const useGetAudiencCategoryeOptions = () =>
  useQuery([], () => {
    return get({
      url: "api/v1/audience/audienceCategoryOptions",
    });
  });
